// Exact copy except import UserService from shared
import { Component, OnInit, AfterViewChecked, ViewChild, Output, EventEmitter }
from "@angular/core";
import { User, Diocese, Organisation, Error, Gender, SecretQuestion, JobTitle }
from "../../models";
import * as moment                      from "moment";
import { Router }               from "@angular/router";
import { NgForm }               from "@angular/forms";
import {NgbDateStruct, NgbDatepickerConfig }
from "@ng-bootstrap/ng-bootstrap";
import { RegistrationService }  from "./registration.service";
import * as swal                from "sweetalert2";
import {NgProgressService} from "ng2-progressbar";
const _ = require("underscore");

@Component({
  template: require("./registration.component.html"),
  styles: [require("./registration.component.less").toString()],
  providers: [RegistrationService, NgbDatepickerConfig]
})
export class RegistrationComponent implements OnInit, AfterViewChecked {
  @Output() handleProcessing: EventEmitter<any> = new EventEmitter();
  user: User;
  dioceseList: Diocese[];
  organisations: Organisation[];
  genders: Gender[];
  jobTitleList: JobTitle[];
  secretQuestions: SecretQuestion[];
  questionList1: SecretQuestion[];
  questionList2: SecretQuestion[];
  questionList3: SecretQuestion[];
  termsAndConditions: string;
  salutations: string[];
  errorMessage: string;
  errors: Error[];
  currentDate: Date = new Date();
  ngbDateOfBirth: NgbDateStruct;
  isProcessing: boolean;
  registrationAttempts: number = 0;
  registrationForm: NgForm;
  @ViewChild("registrationForm") currentForm: NgForm;
  @ViewChild("submitButton") submitButton;

  constructor(private pService: NgProgressService, private registrationService: RegistrationService,
  private _router: Router,
  private config: NgbDatepickerConfig) {
    config.minDate = { year: 1900, month: 2, day: 1 };
    config.maxDate = { year: this.currentDate.getFullYear() - 17, month: 12, day: 31 };
    config.startDate = { year: this.currentDate.getFullYear() - 17, month: 12};
    this.user = new User();
    this.user.organisations = [new Organisation()];
    this.isProcessing = false;
    window["recaptchaCallback"] = this.recaptchaCallback.bind(this);
    window["recaptchaExpired"] = this.recaptchaExpired.bind(this);
  }

  displayRecaptcha() {
    let doc = <HTMLDivElement>document.getElementById("signup-form");
    let script = document.createElement("script");
    script.innerHTML = "";
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    doc.appendChild(script);
  }

  recaptchaCallback(response) {
    this.user.recaptchaResponse = response;
    this.submitButton.nativeElement.disabled = this.IsCreateButtonDisabled();
  }

  recaptchaExpired(response) {
    this.user.recaptchaResponse = null;
    this.submitButton.nativeElement.disabled = this.IsCreateButtonDisabled();
  }

  IsCreateButtonDisabled() {
    return !this.user.termsAccepted || !this.currentForm.valid || this.currentForm.pending || this.isProcessing || !this.user.recaptchaResponse;
  }
  ngOnInit() {
    this.errorMessage = "";
    this.errors = [];
    //Get salutations from API
    this.salutations = ["Mr", "Mrs", "Ms", "Miss", "Prof", "Sr", "Br", "Fr", "Rev", "Bishop", "Dr"];
    // Get diocese list
    this.registrationService
      .GetDioceseList()
      .subscribe(
      (response: Diocese[]) => {
        this.dioceseList = response;
      },
      (error) => {
        this.HandleErrors(error, true);
      });
    // Get secret questions
     
    this.registrationService
      .GetSecretQuestions()
      .subscribe(
      (response: SecretQuestion[]) => {
        this.pService.start();
        this.secretQuestions = response;
        this.questionList1 = this.secretQuestions;
        this.questionList2 = this.secretQuestions;
        this.questionList3 = this.secretQuestions;
        this.pService.done();
      },
      (error) => {
        this.HandleErrors(error, true);
      });
    // Get job titles
    this.GetJobTitles();
    this.user.dateOfBirth = null;
    this.genders = [{ code: "F", name: "Female" }, { code: "M", name: "Male" }];
    this.termsAndConditions = "Applications accessed via the CSNSW NETiD site may contain confidential information collected to promote the welfare and development of students enrolled by NSW Catholic schools. This information is only collected to the extent necessary to ensure appropriate service to the individuals involved and to ensure that CSCNSW can fulfil its duty of care including its duties in relation to the care and protection of children and young people. All persons accessing applications via the CSNSW NETiD site should be aware of their responsibility for maintaining the confidentiality and privacy of student records and accept that a duty of confidence applies and that information cannot further be disclosed without the information provider's consent. If a disclosure is made which is not permitted under either common law or privacy legislation penalties may apply.";
    this.displayRecaptcha();
  }

  onSubmit() {
       this.pService.start();
    this.errorMessage = "";
    this.errors = [];
    this.isProcessing = true;
    this.handleProcessing.emit(true);

    if (!this.validateEmail(this.user.organisations[0].email)) {
      this.errorMessage = "Input validation failed:";
      this.errors.push({ code: "email", message: "Please provide a valid email address" });
      swal({
        title: "Input validation failed!",
        text: "Please provide a valid email address.",
        type: "error",
        showCancelButton: false,
        confirmButtonText: "Ok"
      });
      this.isProcessing = false;
      return;
    }

    if (this.user.password !== this.user.confirmPassword) {
      this.registrationAttempts += 1;
      this.errorMessage = "Input validation failed:";
      this.errors.push({ code: "confirmPassword", message: "Passwords do not match" });
      swal({
        title: "Input validation failed!",
        text: "Password and confirm password do not match.",
        type: "error",
        showCancelButton: false,
        confirmButtonText: "Ok"
      });
      this.isProcessing = false;
      return;
    }
    // validate duplicate accounts again
    this.ValidateDuplicateAccount(() => {
      // Set job title before submit
      if (this.user.organisations[0].jobTitle === "Other" && this.user.organisations[0].otherJobTitle) {
        this.user.organisations[0].jobTitle = this.user.organisations[0].otherJobTitle;
      }

      let organ = this.organisations.find( o => o.publicId === this.user.organisations[0].extOrganisationId)
      this.user.organisations[0].isDioceseOffice = organ.isDioceseOffice;
      
      // Register user
      this.registrationService
        .Save(this.user)
        .subscribe(
        (response: User) => this._router.navigate(["/confirmation"]),
        (error) => {
          let parsed = this.HandleErrors(error, true);
          if (parsed.errors[0] && parsed.errors.length > 0 && parsed.errors[0].code === "duplicate_userid") {
            swal(
              "Duplicate generated User ID!",
              parsed.errors[0].message,
              "error"
            );
          } else {
            swal(
              "Failed to create new account!",
              "Please see the error(s) list at the bottom of the page.",
              "error"
            );
          }
        })
        .add(t => {
          this.isProcessing = false;
          this.handleProcessing.emit(false);
        });
      this.pService.done();
    }, () => {
      this.pService.done();
    });

  }

  onNameChanged(event) {
    this.GenerateNewUserId(this.user.firstName, this.user.lastName);
    this.CheckIfNameCombinationLocked(() => {
      this.ValidateDuplicateAccount(null, null);
    }, null);
  }

  onDateOfBirthChange(dateOfBirth) {
    this.ngbDateOfBirth = dateOfBirth;
    this.user.dateOfBirth = (dateOfBirth ? new Date(this.ngbDateOfBirth.year, this.ngbDateOfBirth.month - 1, this.ngbDateOfBirth.day) : null);
    this.ValidateDuplicateAccount(null, null);
  }

  onMobileChanged() {
    this.ValidateDuplicateAccount(null, null);
  }

  public onHandleProcessing(isProcessing) {
    this.isProcessing = isProcessing;
  }

  onJobTitleChange(jobTitle) {
    this.user.organisations[0].jobTitle = jobTitle;
    // Reset other job title
    if (jobTitle !== "Other") {
      this.user.organisations[0].otherJobTitle = "";
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  // endRegion: Event handlers

  public GetJobTitles() {
    // Get global roles list list
    this.registrationService
      .GetJobTitles()
      .subscribe(
      (response: JobTitle[]) => {
        this.jobTitleList = _.sortBy(response, "name");
      },
      (error) => {
        this.HandleErrors(error, false);
      });
  }
  // On salutation change
  public GenderOnSalutationChange(salutation) {
    this.user.salutationCode = salutation;
    switch (this.user.salutationCode) {
      case "Mr":
      case "Fr":
      case "Br":
      case "Rev":
      case "Bishop":
        this.user.gender = "M";
        break;
      case "Mrs":
      case "Miss":
      case "Ms":
      case "Sr":
        this.user.gender = "F";
        break;
      default:
        this.user.gender = "";
    }
  }

  // On cancel registration
  public CancelRegistration() {
    this._router.navigate(["/home"]);
  }

  // /** Display a message briefly, then remove it. */
  displayMessage(msg: string) {
    this.errorMessage = msg;
    setTimeout(() => this.errorMessage = "", 1500);
  }

  public GetOrganisationList(diocesePublicId) {
    this.registrationService
      .GetOrganisationsByDiocese(diocesePublicId)
      .subscribe(
      (response: Organisation[]) => {
        this.organisations = response;
      },
      (error) => {
        this.HandleErrors(error, false);
      });
  }

  public GetOrganisationListByDioceseId(dioceseId) {
    this.registrationService
      .GetOrganisationsByDioceseId(dioceseId)
      .subscribe(
      (response: Organisation[]) => {
        this.organisations = response;
      },
      (error) => {
        this.HandleErrors(error, false);
      });
  }

  // On salutation change
  public UpdateQuestionList(questionIdName, questionIdValue: number) {
    switch (questionIdName) {
      case "secretQuestion1Id":
        this.user.secretQuestion1Id = questionIdValue;
        this.questionList2 = this.secretQuestions.filter(s => s.id != questionIdValue && s.id != this.user.secretQuestion3Id);
        this.questionList3 = this.secretQuestions.filter(s => s.id != questionIdValue && s.id != this.user.secretQuestion2Id);
        break;
      case "secretQuestion2Id":
        this.user.secretQuestion2Id = questionIdValue;
        this.questionList1 = this.secretQuestions.filter(s => s.id != questionIdValue && s.id != this.user.secretQuestion3Id);
        this.questionList3 = this.secretQuestions.filter(s => s.id != questionIdValue && s.id != this.user.secretQuestion1Id);
        break;
      case "secretQuestion3Id":
        this.user.secretQuestion3Id = questionIdValue;
        this.questionList1 = this.secretQuestions.filter(s => s.id != questionIdValue && s.id != this.user.secretQuestion2Id);
        this.questionList2 = this.secretQuestions.filter(s => s.id != questionIdValue && s.id != this.user.secretQuestion1Id);
        break;
    }
  }

  private HandleErrors(error, userCaused: boolean) {
    this.registrationAttempts += (userCaused ? 1 : 0);
    let parsedErrors = JSON.parse(error._body);
    if (parsedErrors) {
      this.errorMessage = parsedErrors.message;
      this.errors = parsedErrors.errors;
      return parsedErrors;
    }
  }

  private CheckIfNameCombinationLocked(onNameUnlocked: () => void, onNameLocked: () => void) {
    this.registrationService.IsNameCombinationLocked(this.user.firstName, this.user.lastName)
      .subscribe(
      (response: string) => {
        this.errorMessage = "";
        this.errors = [];
        if (onNameUnlocked) onNameUnlocked.apply(this);
      },
      (error) => {
        this.currentForm.resetForm();
        let parsed = this.HandleErrors(error, true);
        swal(
          "First and last name combination locked!",
          parsed.errors[0].message,
          "error"
        );
        if (onNameLocked) onNameLocked.apply(this);
      });
  }

  private ValidateDuplicateAccount(onNoDuplicateFound: () => void, onDuplicateFound: () => void) {
    // at least 3 variables need to have non-empty values, both first and last name and either one of date of birth or mobile
    if (!(this.user.firstName && this.user.lastName && (this.user.mobile || this.user.dateOfBirth))) return;

    // take care of unwanted behavior when dateOfBirth is null or empty
    let dateString = this.user.dateOfBirth == null ? "" : moment(this.user.dateOfBirth).format("YYYY-MM-DD");

    this.registrationService.IsDuplicateAccount(this.user.firstName, this.user.lastName, dateString, this.user.mobile)
      .subscribe(
      (response: string) => {
        this.errorMessage = "";
        this.errors = [];
        if (onNoDuplicateFound) onNoDuplicateFound.apply(this);
      },
      (error) => {
        this.currentForm.resetForm();
        let parsed = this.HandleErrors(error, true);
        swal(
          "Account already exists!",
          parsed.errors[0].message,
          "error"
        );
        if (onDuplicateFound) onDuplicateFound.apply(this);
      });
  }

  public GenerateNewUserId(firstName: string, lastName: string) {
    // both first and last name need to be present before the new user id can be generated
    if (!(firstName && lastName)) return;

    this.registrationService
      .GenerateUserIdForNewAccount(firstName, lastName)
      .subscribe(
      (response: string) => {
        this.errorMessage = "";
        this.errors = [];
        this.user.userId = response;
      });
  }
  
  ngAfterViewChecked() {
    // Comment this out for the time being
    //this.formChanged();
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/registration/registration.component.ts